import { Controller } from "stimulus"
import ga from "../utils/ga"

export default class extends Controller {
  static targets = ["video"]
  static values = {
    loaded: Boolean,
    itemId: String,
    itemType: String,
    playing: Boolean,
    category: String,
    index: String,
  }

  mouseOver() {
    this.playVideo()
  }

  mouseOut() {
    this.pauseVideo()
  }

  playVideo() {
    if (this.hasVideoTarget) {
      const videoPromise = this.videoTarget.play()
      if (typeof videoPromise !== "undefined") {
        videoPromise
          .then(() => {
            if (!this.loadedValue) {
              this.loadedValue = true
              this.logVideoPreviewEvent()
            }
            this.playingValue = true
          })
          .catch(() => {})
      }
    }
  }

  pauseVideo() {
    if (this.hasVideoTarget && this.playingValue) {
      // Only pause if video is actually playing
      // Re: https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
      this.videoTarget.pause()
    }
    this.playingValue = false
  }

  logVideoPreviewEvent() {
    ga("send", {
      hitType: "event",
      eventAction: "hover",
      eventCategory: `Elements API;${this.categoryValue}`,
      eventLabel: this.itemIdValue,
      eventValue: this.indexValue,
      nonInteraction: true,
    })
  }
}
